import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowPathDown"><Path d="M2.79688 13H8.00064V2H16.0006V13H21.2044L12.0006 23.5186L2.79688 13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowPathDown;
